<template>
  <v-card class="my-2 px-4 py-3 v-card-referral" color="white" style="width: 100%; border-radius: 0.75rem">
    <v-container fluid class="ma-0 pa-0" style="width: 100%">
      <v-row>
        <v-col class="col-1">
          <v-icon>fa-fw {{ icon }}</v-icon>
        </v-col>
        <v-col class="col">
          <v-row class="subtitle-1 text-uppercase mb-2" style="font-weight: 600;line-height: 1;letter-spacing:0.015em">
            {{ reportName }}
          </v-row>
          <v-row>Last updated: {{ reportUpdated }}</v-row>
        </v-col>
        <v-col v-if="reportUpdated != 'Not run yet'">
          <v-btn icon :loading="isDownloading" @click="download">
            <v-icon color="grey">fas fa-cloud-download-alt</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ReportCard',
  props: {
    reportId: String,
    reportName: String,
    reportUpdated: String,
    reportType: String
  },
  data: () => ({
    isDownloading: false
  }),
  computed: {
    icon() {
      switch (this.reportType) {
        case 'doc':
        case 'docx':
        case 'odt':
          return 'fas fa-file-word';
        case 'xls':
        case 'xlsx':
        case 'ods':
        case 'csv':
          return 'fas fa-file-excel';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
          return 'fas fa-file-image';
        case 'pdf':
          return 'fas fa-file-pdf';
        default:
          return 'fas fa-file-alt';
      }
    }
  },
  methods: {
    ...mapActions(['downloadReport']),
    async download() {
      this.isDownloading = true;
      await this.downloadReport(this.reportId);
      this.isDownloading = false;
    }
  }
};
</script>
